module.exports = __webpack_public_path__ + "/img/DFN-3-Labeled-iqiCwP.svg";